export default [
  { title: "Auth", icon: "", link: "/docs/auth/autentifikasi" },
  { title: "Token", icon: "", link: "/docs/auth/token" },
  // { title: "Request Header", icon: "", link: "/docs/auth/request-header" },
  // { title: "Request Body", icon: "", link: "/docs/auth/request-body" },
  // { title: "Contoh Request", icon: "", link: "/docs/auth/contoh-request" },
  // { title: "Contoh Response", icon: "", link: "/docs/auth/contoh-response" },		
];
